// extracted by mini-css-extract-plugin
module.exports = {"TopicsMenuWarrper":"MainMenu_TopicsMenuWarrper__2P3c_","CourseNameWarrper":"MainMenu_CourseNameWarrper__1g7RB","TopicsContainer":"MainMenu_TopicsContainer__2HChK"};